import { Inject, Injectable } from '@angular/core';
import * as Rollbar from 'rollbar';

import { IInternalUser } from '@app/interfaces';

@Injectable({
    providedIn: 'root'
})
export class LucienDataService {
    private _clientUtilityInfo: IInternalUser = null;
    private _isInternalUser = false;

    constructor() {}

    public setClientUtilityInfo(info: IInternalUser): void {
        this._clientUtilityInfo = info;
    }

    public get clientUtilityInfo(): IInternalUser {
        return this._clientUtilityInfo;
    }

    public setIsInternalUser(isInternalUser: boolean): void {
        this._isInternalUser = isInternalUser;
    }

    public get isInternalUser(): boolean {
        return this._isInternalUser;
    }
}
